import { Head } from '@inertiajs/react';
import { MainLayout } from '../../layouts/MainLayout';
import { SeresQueridosHero } from '../../components/seres-queridos-landing/SeresQueridosHero';
import { HowItWorks } from '../../components/seres-queridos-landing/HowItWorks';
import { TrustSection } from '../../components/seres-queridos-landing/TrustSection';
import { FAQ } from '../../components/seres-queridos-landing/FAQ';
import { FinalCTA } from '../../components/seres-queridos-landing/FinalCTA';
import { SEOBlock } from '../../components/seres-queridos-landing/SEOBlock';
import type { SeresQueridosLandingProps } from '../../types/seres-queridos-landing';

export default function SeresQueridosLanding({ appUrl, loginUrl, whatsappUrl }: SeresQueridosLandingProps) {
  return (
    <MainLayout>
      <Head>
        <title>Comprá para que a tus seres queridos no les falte nada | Abasto Virtual</title>
        <meta
          name="description"
          content="Pedís vos desde el celular y llevamos frutas y verduras frescas hasta su puerta, el día y en la franja horaria que elijas. Entregas en Córdoba."
        />
        <link rel="canonical" href={`${appUrl}/seres-queridos`} />
      </Head>

      <SeresQueridosHero loginUrl={loginUrl} whatsappUrl={whatsappUrl} />
      <HowItWorks />
      <TrustSection />
      <FAQ />
      <FinalCTA loginUrl={loginUrl} whatsappUrl={whatsappUrl} />
      <SEOBlock appUrl={appUrl} />
    </MainLayout>
  );
}
